import { ODDS_SCREEN_LEAGUE_IDS } from "./league-ids.mjs";

export type OddsScreenSport = {
  id: string;
  label: string;
  leagues: string[];
  slug: string;
  seasonal?: boolean;
};

export const ODDS_SCREEN_SPORTS: OddsScreenSport[] = [
  { id: "basketball", label: "Basketball", leagues: ["nba", "ncaab", "wnba"], slug: "basketball" },
  { id: "hockey", label: "Hockey", leagues: [], slug: "hockey" },
  { id: "football", label: "Football", leagues: ["nfl", "cfb"], slug: "football", seasonal: true },
  { id: "baseball", label: "Baseball", leagues: ["mlb"], slug: "baseball" },
  { id: "soccer", label: "Soccer", leagues: ["soccer"], slug: "soccer" },
  { id: "tennis", label: "Tennis", leagues: ["tennis"], slug: "tennis" },
  { id: "mma", label: "MMA", leagues: ["mma"], slug: "mma" },
];

export function getSportBySlug(slug: string): OddsScreenSport | undefined {
  return ODDS_SCREEN_SPORTS.find((s) => s.slug === slug);
}

export { ODDS_SCREEN_LEAGUE_IDS };

export function isOddsScreenLeagueId(id: string): boolean {
  return ODDS_SCREEN_LEAGUE_IDS.includes(id);
}
